import { Box, Button, Grid, Alert } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { OrderPayload } from 'pages/myidm/store';
// import FormCard from 'pages/myidm/components/form-card';
import React from 'react';
import { useRecoilState } from 'recoil';
import { useMutation } from 'react-query';
import axios from 'api/request';
import { endPoints } from 'api/endpoints';
import DisableGroupList from 'pages/myidm/components/sections/ad-group-disable/DisableGroupList';
import DisableSummary from 'pages/myidm/components/sections/ad-group-disable/DisableSummary';
import { CancelRequest } from 'pages/myidm/components/CancelRequest';
import { SubmitRequest } from 'pages/myidm/components/sections/ad-group-disable/SubmitRequest';
import { AD_GROUP, REQUEST_TYPE, MODIFY_REQUEST_TYPE } from 'pages/myidm/utils/constant';
import ADGroup from './ADGroup';

const ResourceSection = () => {
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [showMembersAlert, setShowMembersAlert] = React.useState(false);
    const adGroupMembersApi = useMutation(() => axios.get(`${endPoints?.myIdm?.adGroupMembersApi}/${order?.adGroup}`));
    const adGroupDetailsApi = useMutation(() => axios.get(`${endPoints.myIdm.adGroupDetailsApi}/${order?.adGroup}`));

    const handleAddAdGroupForDisable = async () => {
        const [membersResponse, detailsResponse] = await Promise.all([adGroupMembersApi.mutateAsync(), adGroupDetailsApi.mutateAsync()]);

        const members = membersResponse?.data || [];
        // Check if the AD group has members
        if (members && members.length > 0) {
            setShowMembersAlert(true);
            return;
        }

        const adGroupData = detailsResponse?.data?.[0] || {};
        const { adgroupOwnerId, adgroupOwnerName, adgroupType } = adGroupData;
        const adGroupOwner = adgroupOwnerId && adgroupOwnerName ? `${adgroupOwnerId}-${adgroupOwnerName}` : '';

        setOrder((prevOrder) => ({
            ...prevOrder,
            adGroup: null,
            adGroupListForDisable: [...(prevOrder?.adGroupListForDisable || []), { adGroup: prevOrder?.adGroup, adGroupOwner, adgroupType, members }],
        }));
        setShowMembersAlert(false);
    };

    const handleDeleteAdGroupForDisable = (index) => {
        setOrder((prevOrder) => {
            const updatedGroups = [...(prevOrder?.adGroupListForDisable || [])];
            updatedGroups.splice(index, 1);
            return {
                ...prevOrder,
                adGroupListForDisable: updatedGroups,
            };
        });
    };

    const handleConfirmationChange = (event) => {
        setOrder((prevOrder) => ({
            ...prevOrder,
            disableConfirmationChecked: event.target.checked,
        }));
    };

    const handleRemoveMembersClick = () => {
        setOrder((prevOrder) => ({
            ...prevOrder,
            typeOfRequest: REQUEST_TYPE.MODIFY,
            modifyRequestType: MODIFY_REQUEST_TYPE.REMOVAL,
            groupType: AD_GROUP,
            sector: null,
            environment: null,
            envShortName: null,
            businessApplication: null,
            businessApplicationDetails: null,
            appOwner: null,
            appOwnerDetails: null,
            adGroup: null,
            adGroupType: null,
            adGroupTypeDetails: null,
            groupOwner: null,
            groupOwnerDetails: null,
            adGroupOwner: null,
        }));
        setShowMembersAlert(false);
    };

    const isAlreadyAdded = order?.adGroup && order?.adGroupListForDisable?.some((group) => group.adGroup === order?.adGroup);

    return (
        // <FormCard title="Resource" gap={0} margin={2}>
        //     <Grid item container spacing={2} sx={{ mt: 2, mb: 2 }}>
        <>
            {showMembersAlert && (
                <Grid item xs={12}>
                    <Alert severity="error" onClose={() => setShowMembersAlert(false)}>
                        Selected Active Directory Group has members, please make sure to{' '}
                        <Box
                            component="span"
                            sx={{
                                color: 'primary.main',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                                fontWeight: 'bold',
                            }}
                            onClick={handleRemoveMembersClick}
                        >
                            remove the members
                        </Box>{' '}
                        from the Active Directory Group and search for the Active Directory Group.
                    </Alert>
                </Grid>
            )}
            <Grid item md={6} sm={6} xs={12}>
                <ADGroup onInputChange={() => setShowMembersAlert(false)} />
            </Grid>
            <Grid item md={6} sm={6} xs={6}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                    <Button
                        variant="contained"
                        color="cmpPrimary"
                        onClick={handleAddAdGroupForDisable}
                        sx={{ minWidth: '42px', width: '42px', height: '32px' }}
                        disableFocusRipple
                        disableRipple
                        data-testid="add-btn"
                        disabled={!order?.adGroup || isAlreadyAdded || adGroupMembersApi.isLoading || adGroupDetailsApi.isLoading}
                    >
                        <AddIcon sx={{ fontSize: '25px' }} />
                    </Button>
                </Box>
            </Grid>
            {/* Display list of selected groups */}
            <Grid item xs={12}>
                <DisableGroupList groups={order?.adGroupListForDisable || []} onDelete={handleDeleteAdGroupForDisable} />
            </Grid>
            {/* Display summary */}
            <Grid item xs={12}>
                <DisableSummary
                    groups={order?.adGroupListForDisable || []}
                    checked={order?.disableConfirmationChecked || false}
                    onCheckboxChange={handleConfirmationChange}
                    isTouched={order?.isTouched || false}
                />
                {order?.adGroupListForDisable?.length > 0 && (
                    <Box display="flex" flexDirection="row-reverse" gap={1} sx={{ mt: 2, alignItems: 'baseline' }}>
                        <Box sx={{ marginTop: '0px' }}>
                            <CancelRequest />
                        </Box>
                        <SubmitRequest />
                    </Box>
                )}
            </Grid>
        </>
        //     </Grid>
        // </FormCard>
    );
};

export default ResourceSection;
